import React, { FC, useEffect } from 'react'
import { motion } from 'framer-motion'
import PureCounter from '@srexi/purecounterjs'

interface StatItem {
  label: string
  value: number
}

interface CompanyStatsPropsType {
  yellowRef: any
  greenRef: any
  purpleRef: any
  data?: StatItem[]
}

const CompanyStats: FC<CompanyStatsPropsType> = ({
  yellowRef,
  greenRef,
  purpleRef,
  data,
}) => {
  const stats: StatItem[] =
    data && data.length > 0
      ? data
      : [
          { label: 'Years building AI & automation systems', value: 10 },
          { label: 'Production systems shipped globally', value: 120 },
          { label: 'In-house engineers, zero outsourcing', value: 25 },
          { label: 'Markets: US · UK · EU · SEA', value: 4 },
        ]

  useEffect(() => {
    new PureCounter()
  }, [])

  const refs = [yellowRef, greenRef, purpleRef, null]

  return (
    <section className="relative px-4 py-10 md:px-8 xl:px-14">
      <div className="relative mx-auto max-w-[1950px] overflow-hidden border-[2px] border-[#1F1F1F] bg-[#141414]">
        <div className="grid grid-cols-2 md:grid-cols-4">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{
                opacity: 0,
                scale: 0.5,
              }}
              whileInView={{
                opacity: 1,
                scale: 1,
              }}
              transition={{
                duration: 0.7,
                delay: index * 0.15,
                ease: 'easeOut',
              }}
              viewport={{ once: false }}
              className="group relative flex flex-col items-center justify-start md:justify-center overflow-hidden px-3 py-5 text-center transition-all duration-500 md:min-h-[100px] md:py-3 lg:min-h-[100px] lg:px-8 lg:py-6 xl:py-10"
            >
              {/* GLOW */}
              <div
                className="absolute left-1/2 top-1/2 h-[40px] w-[40px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-100 blur-[30px] md:h-[30px] md:w-[30px] lg:h-[40px] lg:w-[40px] xl:h-[60px] xl:w-[60px] xl:blur-[50px]"
                style={{
                  background: '#229CFF',
                }}
              />

              {/* DIVIDER */}
              {index !== stats.length - 1 && (
                <div className="absolute right-0 top-1/2  h-full w-[2px] -translate-y-1/2 bg-[#1F1F1F]" />
              )}

              {/* CONTENT */}
              <div className="relative z-10">
                <div className="flex items-center justify-center font-google-sans-bold text-[#229CFF]">
                  <div
                    className="purecounter font-google-sans-bold text-[30px] text-[#229CFF] md:text-[25px] xl:text-[40px] 2xl:text-[40px]"
                    data-purecounter-start="0"
                    data-purecounter-end={String(stat.value)}
                    data-purecounter-duration="2"
                  />

                  <span className="ml-1 font-google-sans-bold text-[30px] text-[#229CFF] md:text-[25px] xl:text-[40px] 2xl:text-[40px]">
                    +
                  </span>
                </div>

                <p className="mx-auto md:mt-3 max-w-[250px] font-google-sans-medium text-sm leading-relaxed text-white md:text-[12px] lg:text-[15px] xl:mt-5 xl:text-[18px] 2xl:text-[20px]">
                  {stat.label}
                </p>
              </div>

              {refs[index] && (
                <div ref={refs[index]} className="hidden" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CompanyStats